<template>
  <div>
    <LoadingSpinner :loading="isLoading" :text="$lang.sending_data" />
    <examPackFrom
      v-show="!isLoading"
      :title="$lang.azmoonLang.azmoonAdd"
      mode="add"
      @handleBack="close"
      @submit="save"
    />
  </div>
</template>

<script>
import examPackFrom from "./../from/examPackFrom";
import LoadingSpinner from "@/components/base/LoadingSpinner";

export default {
  name: "add_azmoon",
  components: {
    examPackFrom,
    LoadingSpinner,
  },
  inject: ["examPackRepository"],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getItems() {
      this.$emit("getItems");
    },
    async save(payload) {
      try {
        this.isLoading = true;
        const response = await this.examPackRepository.create(payload);
        this.$notify.success(response.data.message);
        this.close();
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

